import * as React from "react";
import cx from "classnames";

import { Product } from "../../../models";

export interface ProductItemProps extends Product {
  onClick: (e: any) => void;
  active?: boolean;
}

const getMainClasses = ({ active }: ProductItemProps) =>
  cx("product-list__item", {
    "product-list__item--active": active,
  });

const ProductItem = (props: ProductItemProps) =>
  <li className={getMainClasses(props)} onClick={props.onClick}>
    <div
      className="product-list__item-icon"
      style={{ backgroundImage: `url(${props.logo})` }}
    />
    <p>
      {props.name}
    </p>
  </li>;

export default ProductItem;



// WEBPACK FOOTER //
// ./src/routes/Step1/components/ProductItem.tsx